import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeContact: null,
};

const activeContactSlice = createSlice({
  name: "activeContact",
  initialState,
  reducers: {
    setActiveContact: (state, action) => {
      
      state.activeContact = action.payload;
    },
    clearActiveContact: (state) => {
      state.activeContact = null;
    },

  },
});

export const { setActiveContact, clearActiveContact } = activeContactSlice.actions;
export default activeContactSlice.reducer;
